import { render, staticRenderFns } from "./ScoreSettingEdit.vue?vue&type=template&id=501d1aa6"
import script from "../../../controllers/custom/score_setting/score-setting-edit.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/score_setting/score-setting-edit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports